// extracted by mini-css-extract-plugin
module.exports = {"container":"AxisSettings-container-2P7BSL","fieldLabel":"AxisSettings-fieldLabel-EQaqft","ranges":"AxisSettings-ranges-3ZmpKi","rangeCol":"AxisSettings-rangeCol-27_ci8"};